import Base from './Base';

export default Base;



// WEBPACK FOOTER //
// ./src/common/components/Base/index.js